
import React from 'react'

export const PilotRankCircle = ({rank, ...props}) => {
    
    const getRankImage = () => {
        if(rank.title.toLowerCase() == 'bronze')
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/bronze-lean.png'} className="pilot-rank-circle" />
        else if(rank.title.toLowerCase() == 'silver')
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/silver-lean.png'} className="pilot-rank-circle" />
        else if(rank.title.toLowerCase() == 'gold')
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/gold-lean.png'} className="pilot-rank-circle" />
        else if(rank.title.toLowerCase() == 'platinum')
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/platinum-lean.png'} className="pilot-rank-circle" />
        else if(rank.title.toLowerCase() == 'diamond')
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/diamond-lean.png'} className="pilot-rank-circle" />
        else
            return <img src={process.env.PUBLIC_URL + '/assets/ranks/silver-lean.png'} className="pilot-rank-circle" />
    }

    return getRankImage()
}
